/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams, WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams, WebAppGetYoutubeIntegrationBroadcastsBroadcasts401, WebAppGetYoutubeIntegrationBroadcastsBroadcasts403 } from "../models/WebAppGetYoutubeIntegrationBroadcastsBroadcasts";
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
import { webAppGetYoutubeIntegrationBroadcastsBroadcasts } from "../axios/webAppGetYoutubeIntegrationBroadcastsBroadcasts";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const webAppGetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey = (station: WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams) => ["api-v2", { url: '/web-app/v1/youtube-broadcasts/:station', params: {station:station} }, ...(params ? [params] : [])] as const

export type WebAppGetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey = ReturnType<typeof webAppGetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey>

export function webAppGetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryOptions(station: WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey(station, params)
        return queryOptions<WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationBroadcastsBroadcasts401 | WebAppGetYoutubeIntegrationBroadcastsBroadcasts403>, WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetYoutubeIntegrationBroadcastsBroadcasts(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Computes on-air intervals from stream gaps in the requested window and enriches them with live/ended YouTube video metadata for the station channel.
 * @summary List on-air broadcasts for a station
 * {@link /web-app/v1/youtube-broadcasts/:station}
 */
export function useWebAppGetYoutubeIntegrationBroadcastsBroadcastsSuspense<TData = WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, TQueryKey extends QueryKey = WebAppGetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey>(station: WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams, options: 
{
  query?: Partial<UseSuspenseQueryOptions<WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationBroadcastsBroadcasts401 | WebAppGetYoutubeIntegrationBroadcastsBroadcasts403>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryKey(station, params)
         

         const query = useSuspenseQuery({
          ...webAppGetYoutubeIntegrationBroadcastsBroadcastsSuspenseQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<WebAppGetYoutubeIntegrationBroadcastsBroadcasts401 | WebAppGetYoutubeIntegrationBroadcastsBroadcasts403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}